var on_mobile = false;
  
$(document).ready(function() {  
  // $('.customer-reviews-section-panels').click(function() {
  //    var newWindowWidth = $(window).width();
  //     if (newWindowWidth < 768) {
  //       $(this).toggleClass('active');
  //     }
  // });
  $('.featured-collection-slider').owlCarousel({
    items:2,
    dots: false,
    arrows: false,
    loop:true,
    margin:10,
    center: true,
    responsive:{
        600:{
            items: 4
        }
      }
  });
  
  $(window).on("resize", function (e) {
      checkScreenSize();
  });

  checkScreenSize();
  
  function checkScreenSize(){
      var newWindowWidth = $(window).width();
      if (newWindowWidth < 768) {
        on_mobile = true;
        $('.customer-reviews-section-panels').addClass('active');
        $('body:not(.tempsuffx-recipes) .recipes-section-row').addClass('owl-carousel');
        $('body:not(.tempsuffx-recipes) .recipes-section-row').owlCarousel({
          items:1,
          dots: true,
          arrows: false,
          loop:true,
          margin:10,
          stagePadding: 40
        });
      }
      else
      {
        if (typeof $('body:not(.tempsuffx-recipes) .recipes-section-row').data('owl.carousel') != 'undefined') {
          $('body:not(.tempsuffx-recipes) .recipes-section-row').data('owl.carousel').destroy();
        }
        $('body:not(.tempsuffx-recipes) .recipes-section-row').removeClass('owl-carousel');
      }
    // console.log('p1:',on_mobile);
  }
  $('.product-info-detail-tab-item').click(function() {
    var indx = $(this).attr('index');
    $('.product-info-detail-tab-item').removeClass('active');
    $(this).addClass('active');
    $('.product-info-detail-tab-panel-containe').hide();
    $('.product-info-detail-tab-panel-containe[index="'+indx+'"]').show();
  });

  $('.customer-reviews-tab-item').click(function() {
    var indx = $(this).attr('indx');
    $('.customer-reviews-tab-item').removeClass('active');
    $(this).addClass('active');
    $('.customer-reviews-section-panels').removeClass('active');
    $('.customer-reviews-section-panels[indx="'+indx+'"]').addClass('active');    
  });

  $(document).on('click', '.bottle-bundle-quantity-btn-up', function() {
    var v = $(this).parents('.bottle-bundle-quantity').find('input').val();
    v = parseInt(v);
    v = v + 1;
    $(this).parents('.bottle-bundle-quantity').find('input').val(v)
  });
  $(document).on('click', '.bottle-bundle-quantity-btn-down', function() {
    var v = $(this).parents('.bottle-bundle-quantity').find('input').val();
    v = parseInt(v);
    if (v > 1) {
      v = v - 1;
    }
    $(this).parents('.bottle-bundle-quantity').find('input').val(v)
  });

  $('.image-wrap.showonhover img').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('ffdfdff')
    $(this).parents('.grid-product').find('form .add-to-cart').trigger('click');
  });

  $('.thumbnails_carousel li').click(function() {
    var img = $(this).attr('mainimg');
    var url = $(this).attr('urlone');
    $('.home-banner-containe-img_dynamic').parents('a').attr('href', url);
    $('li.thumbnail_ele').removeClass('acti');
    $(this).addClass('acti');
    $('.home-banner-containe-img_dynamic').attr('src', img);
  });
});

function init(){
    if (on_mobile) {
      $(".galleryThumbs_mobile li").each(function(index){
         this.style.backgroundImage = "url('" + this.children[0].src + "')"; 
          if( index != 0)
             this.style.display = "none"; 
      });
    }
    else
    {
      $(".galleryThumbs li").each(function(index){
         this.style.backgroundImage = "url('" + this.children[0].src + "')"; 
         if( index != 0)
           this.style.display = "none"; 
      });
    }
    
    // console.log('p2:',on_mobile);
    setTimeout(changeImage, 4500);
}

function changeImage(){
    // console.log('p3:',on_mobile);

    if (on_mobile) {
    $curr_mobile = $(".galleryThumbs_mobile .active");
    $next_mobile = $(".galleryThumbs_mobile .active").next();
    
    if($next_mobile[0] === undefined)
        $next_mobile = $(".galleryThumbs_mobile img").eq(0);
    
    $curr_mobile.fadeOut(250, function(){
        $next_mobile.fadeIn(250, function(){
            $curr_mobile.removeClass("active");
            $next_mobile.addClass("active");
            setTimeout(changeImage, 4500);
        });   
    }); 
    }
  else
    {
    $curr = $(".galleryThumbs .active");
    $next = $(".galleryThumbs .active").next();
    
    if($next[0] === undefined)
        $next = $(".galleryThumbs img").eq(0);
    
    $curr.fadeOut(250, function(){
        $next.fadeIn(250, function(){
            $curr.removeClass("active");
            $next.addClass("active");
            setTimeout(changeImage, 4500);
        });   
    }); 
      
    }
  
}

$(document).ready(init);

